import { Box, HStack, Skeleton, Text } from "@chakra-ui/react";
import { IconTile } from "../../../shared/ui";

// Card de contagem da visão geral — o StatCard compartilhado formata o valor como moeda.
export default function OverviewMetric({ label, value, icon, tone = "neutral", footnote, isLoading }) {
  return (
    <Box
      role="group"
      aria-label={label}
      bg="app-card"
      border="1px solid"
      borderColor="app-border"
      borderRadius="xl"
      boxShadow="sm"
      p={4}
    >
      <HStack spacing={3} align="flex-start">
        {icon ? <IconTile icon={icon} tone={tone} /> : null}
        <Box minW={0}>
          <Text color="app-muted-fg" fontSize="sm">
            {label}
          </Text>
          {isLoading ? (
            <Skeleton height="28px" width="60px" mt={1} />
          ) : (
            <Text fontSize="2xl" fontWeight="bold" lineHeight="short">
              {value}
            </Text>
          )}
          {footnote ? (
            <Text fontSize="xs" color="app-muted-fg" mt={1}>
              {footnote}
            </Text>
          ) : null}
        </Box>
      </HStack>
    </Box>
  );
}
